export const OpenModal = (id) => {
  const modal = document.getElementById(id) as HTMLDialogElement | null;
  modal?.showModal();
};
